import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=d8a392f6&"
import script from "./CustomerInfo.vue?vue&type=script&lang=ts&"
export * from "./CustomerInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports